import config from "../config"
import {state} from "../stores"
import createLocation from "./location";

const imgCache = {}

export function drawTerrainLayer(terrainId = 'road_plain') {
  const [ctx] = getCanvas("canvasiso");
  const sourceAsset = 'assets/image/'
  const [xLength, yLength] = config.LOCATION_DIMENSION
  const images = {
    grass_1: `${sourceAsset}grass_1.png`,
    road_plain: `${sourceAsset}road_plain.png`,
    water_pond: `${sourceAsset}water_pond.png`,
  }

  let tiles
  state.subscribe(val => {
    if (val?.tiles) {
      tiles = val.tiles
    }
  })

  // set width & height of canvas
  const canvasWidth = config.TILE_WIDTH * xLength
  const canvasHeight = config.TILE_HEIGHT * yLength
  ctx.canvas.width  = canvasWidth;
  ctx.canvas.height = canvasHeight + config.TILE_HEIGHT + config.OFFSET_HEIGHT;
  ctx.clearRect(0, 0, canvasWidth, canvasHeight + config.TILE_HEIGHT + config.OFFSET_HEIGHT);
  // setup a location
  const assetId = terrainId
  const imageUrl= images[assetId]

    asyncImageLoader(imageUrl).then(img => {
      const locationTiles = tiles || createLocation(img, config.LOCATION_DIMENSION)
      
      locationTiles.forEach(item => {
        const posX = item.position.x
        const posY = item.position.y + config.OFFSET_HEIGHT
        ctx.drawImage(img, posX, posY)
        if(item.index === 55) {
          ctx.fillStyle = "red"
        } else {
          ctx.fillStyle = "#000000"
        }
        ctx.fillText(item.index, posX + 14, posY + 11)
      })
      state.update(currentState => ({ ...currentState, tiles: locationTiles, config }))
    })
}

function asyncImageLoader(url){
  return new Promise((resolve, reject) => {
     if (imgCache[url]) {
       resolve(imgCache[url])
     }
      const image = new Image()
      image.src = url
      image.onload = () => resolve(image)
      image.onerror = () => {
        reject(new Error('could not load image'))
      }
  })
}

function getCanvas(id) {
  const canvas = document.getElementById(id)

  const context = canvas.getContext("2d")

  return [context, canvas]
}

function convertAnchorPositionToBottomCenter(currentPosition, tileSize, assetSize) {
  const [curX, curY] = currentPosition;
  const [tileWidth, tileHeight] = tileSize
  const [assetWidth, assetHeight] = assetSize

  const posX = curX - ((assetWidth - tileWidth) / 2)
  const posY = curY - ((assetHeight - tileHeight))

  return [posX, posY]
}

export function drawAssetLayer(img, posX, posY, overrides = []) {
  const tileSize = [36, 18]
  const CANVAS_ID = 'canvas-asset'
  const [xLength, yLength] = config.LOCATION_DIMENSION
  let canvas = document.getElementById(CANVAS_ID)
  if (!canvas){
    canvas = document.createElement('canvas')
    canvas.id = CANVAS_ID
    const parent = document.getElementById("canvasRoot")
    parent.appendChild(canvas)
  }
  const ctx = canvas.getContext("2d")
  // set width & height of canvas
  const canvasWidth = config.TILE_WIDTH * xLength
  const canvasHeight = config.TILE_HEIGHT * yLength
  ctx.canvas.width  = canvasWidth;
  ctx.canvas.height = canvasHeight + config.TILE_HEIGHT + config.OFFSET_HEIGHT;
  ctx.clearRect(0, 0, canvasWidth, canvasHeight + config.TILE_HEIGHT + config.OFFSET_HEIGHT);

  const overrideX = overrides[0] || 0
  const overrideY = overrides[1] || 0
  const [x, y] = convertAnchorPositionToBottomCenter([posX + overrideX, posY + overrideY], tileSize, [img.width, img.height])
  ctx.drawImage(img, x, y)  
}

export function handleSelectFirstFrame(width, height, img){
  const croppedImage = document.createElement("canvas")
  croppedImage.width  = width;
  croppedImage.height = height;
  const ctx = croppedImage.getContext("2d")
  ctx.drawImage(img, 0, 0)
  return croppedImage
}

export function getCoordinateLines(x, y, z, tiles) {
  console.trace("🚀 ~ file: canvas.js ~ line 120 ~ getCoordinateLines ~ x, y, z", x, y, z)
  const tileHeight = 18;
  const tileWidth = 36;
  if (!x || !y || !z) console.log("no box to draw");
  const initIndex = 55;
  const xPath = Array.from({ length: x }).map((_, i) => initIndex - i);
  const yPath = Array.from({ length: y }).map((_, i) => initIndex - i * 10);
  const connectorPath = Array.from({ length: y }).map(
    (_, i) => xPath[xPath.length - 1] - i * 10
  );

  const lowerIndexPosition = [
    connectorPath[connectorPath.length - 1],
    yPath[yPath.length - 1],
    initIndex,
    xPath[xPath.length - 1]
  ].map((idx, i) => {
    const pos = tiles[idx].position
      // anchor top center
      if (i === 0)
        return {...pos, x: pos.x + (tileWidth/2)}
        // anchor middle right
      if (i === 1)
        return {x: pos.x + tileWidth, y: pos.y + (tileHeight/2)}
        // anchor bottom center
      if (i === 2)
        return {x: pos.x + (tileWidth/2), y: pos.y + tileHeight}
        // anchor middle left
      if (i === 3)
        return {...pos, y: pos.y + (tileHeight/2)}
  });

  return lowerIndexPosition;
}

export function drawTemplateLayer(dimensions, tiles) {
  const [x,y,z] = dimensions;
  const tileSize = [36, 18]
  const CANVAS_ID = 'canvas-template'
  const [xLength, yLength] = config.LOCATION_DIMENSION
  let canvas = document.getElementById(CANVAS_ID)
  if (!canvas){
    canvas = document.createElement('canvas')
    canvas.id = CANVAS_ID
    const parent = document.getElementById("canvasRoot")
    parent.appendChild(canvas)
  }
  const ctx = canvas.getContext("2d")
  // set width & height of canvas
  const canvasWidth = config.TILE_WIDTH * xLength
  const canvasHeight = config.TILE_HEIGHT * yLength
  ctx.canvas.width  = canvasWidth;
  ctx.canvas.height = canvasHeight + config.TILE_HEIGHT + config.OFFSET_HEIGHT;
  ctx.clearRect(0, 0, canvasWidth, canvasHeight + config.TILE_HEIGHT + config.OFFSET_HEIGHT);

  const lineCoordinates = getCoordinateLines(x, y, z, tiles)

  
  // draw lower line
  const lineHeight = z * tileSize[1]
  ctx.lineWidth = 2;
  lineCoordinates.forEach((pos, idx) => {
    let from = pos;
    let to = idx === 3 ? lineCoordinates[0] : lineCoordinates[idx + 1];
    // bottom line
    ctx.globalAlpha = 0.7
    ctx.beginPath();
    ctx.strokeStyle = '#3398FF';
    ctx.moveTo(from.x, from.y + config.OFFSET_HEIGHT);
    ctx.lineTo(to.x, to.y + config.OFFSET_HEIGHT);

    if(idx === 0) {
      ctx.moveTo(from.x, from.y + config.OFFSET_HEIGHT);
      ctx.lineTo(from.x, from.y + config.OFFSET_HEIGHT - lineHeight);
    }
    ctx.stroke()
    ctx.closePath();    
    // strigh line
    ctx.beginPath();
    ctx.strokeStyle = '#D733FF';
    if (idx > 0) {
      ctx.moveTo(from.x, from.y + config.OFFSET_HEIGHT);
      ctx.lineTo(from.x, from.y + config.OFFSET_HEIGHT - lineHeight);
    }
    ctx.stroke()
    ctx.closePath();    
    
    // top line
    ctx.beginPath();
    ctx.strokeStyle = '#FF5733';
    ctx.lineTo(from.x, from.y + config.OFFSET_HEIGHT - lineHeight);
    ctx.lineTo(to.x, to.y + config.OFFSET_HEIGHT - lineHeight);
    ctx.stroke()
    ctx.closePath();    
  })

  // draw higher line
}